import * as React from 'react';
import device from '../../../services/mini/device';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type ProjectLeftPanelListItemProps = {
    children: ReactChildrenGeneralType;
    selected: boolean;
    disabled?: boolean;
}

function ProjectLeftPanelListItem({ children, selected, disabled }: ProjectLeftPanelListItemProps) {
    return (
        <div className={`ProjectLeftPanel__list_item ${selected && 'selected'}  ${disabled && 'disabled'} ${!device.isDesktop() ? 'mobile' : ''}`}>
            {children}
        </div>
    );
}

export default ProjectLeftPanelListItem;
